import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Account  {
    _originalTypeClassName = "zERP.BO.Account";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Account.translate = translateService;
}
this.ChildChartOfAccounts = [];
this.AccountCategory = new Domain.AccountCategory();
this.Tags = [];
this.ChartOfAccountID = null;
this.FullCode = null;
this.Code = null;
this.Level = null;
this.Description = null;
this.RefBusinessObject = null;
this.RefBusinessObjectID = null;
this.AccountSign = null;
this.FullName = null;
this._key = this.ChartOfAccountID = 0; 
}

static translate: TranslateService;
_key: any;
private _ChartOfAccountID:any;
get ChartOfAccountID(): any {
    return this._ChartOfAccountID;
  }
set ChartOfAccountID(value: any) {
    this._ChartOfAccountID = value;
    this._key = value;
  }
FullCode:any;
Code:any;
Level:any;
Description:any;
RefBusinessObject:any;
RefBusinessObjectID:any;
AccountSign:any;
FullName:any;
Ledger:any;
FiscalPeriod:any;
ParentChartOfAccount:any;
ChildChartOfAccounts:any;
TAccount:any;
NEWChartOfAccount:any;
AccountCategory:any;
Tags:any;
static setLedger = ($this, value) => {
var oldValue = $this.Ledger;
$this.Ledger = value;
if (value != null) {
if (oldValue != null) {
Domain.Ledger.removeChartOfAccounts(oldValue, $this);
}
Domain.Ledger.addChartOfAccounts(value, $this);
}
}
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
}
}
static setParentChartOfAccount = ($this, value) => {
var oldValue = $this.ParentChartOfAccount;
$this.ParentChartOfAccount = value;
if (value != null) {
if (oldValue != null) {
Domain.Account.removeChildChartOfAccounts(oldValue, $this);
}
Domain.Account.addChildChartOfAccounts(value, $this);
}
}
static setChildChartOfAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.ChildChartOfAccounts == null) $this.ChildChartOfAccounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ChildChartOfAccounts.length > 0) {
                    Domain.Account.removeChildChartOfAccounts($this, $this.ChildChartOfAccounts[0]);
                }

                Domain.Account.addManyChildChartOfAccounts($this, copyItems);
            }
static addManyChildChartOfAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Account.addChildChartOfAccounts($this, items[i]);
                }
            }
static addChildChartOfAccounts = ($this, item) => {
                if ($this.ChildChartOfAccounts == null) $this.ChildChartOfAccounts = [];
                if (item == null || $this.ChildChartOfAccounts.indexOf(item) > -1) return;
                $this.ChildChartOfAccounts.push(item);
if (item.ParentChartOfAccount != $this) {
Domain.Account.setParentChartOfAccount(item, $this);
}
}
static addRangeChildChartOfAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Account.addChildChartOfAccounts($this, item));
            }
static removeChildChartOfAccounts = ($this, item) => {
                if ($this == null || $this.ChildChartOfAccounts == null || $this.ChildChartOfAccounts.indexOf(item) === -1) return;
                var _index = $this.ChildChartOfAccounts.indexOf(item);
                $this.ChildChartOfAccounts.splice(_index, 1);
item.ParentChartOfAccount = null;
}
static clearChildChartOfAccounts = ($this) => { $this.ChildChartOfAccounts = null; }
static setTAccount = ($this, value) => {
var oldValue = $this.TAccount;
$this.TAccount = value;
if (value != null) {
if (oldValue != null && oldValue.ChartOfAccount != null) { oldValue.ChartOfAccount = null; }
if ($this.TAccount.ChartOfAccount !== $this) {
Domain.TAccount.setChartOfAccount(value, $this);
}
}
}
static setNEWChartOfAccount = ($this, value) => {
var oldValue = $this.NEWChartOfAccount;
$this.NEWChartOfAccount = value;
if (value != null) {
}
}
static setAccountCategory = ($this, value) => {
var oldValue = $this.AccountCategory;
$this.AccountCategory = value;
if (value != null) {
}
}
static setTags = ($this, items) => {
                if (items == null) items = [];
                if ($this.Tags == null) $this.Tags = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Tags.length > 0) {
                    Domain.Account.removeTags($this, $this.Tags[0]);
                }

                Domain.Account.addManyTags($this, copyItems);
            }
static addManyTags = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Account.addTags($this, items[i]);
                }
            }
static addTags = ($this, item) => {
                if ($this.Tags == null) $this.Tags = [];
                if (item == null || $this.Tags.indexOf(item) > -1) return;
                $this.Tags.push(item);
}
static addRangeTags = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Account.addTags($this, item));
            }
static removeTags = ($this, item) => {
                if ($this == null || $this.Tags == null || $this.Tags.indexOf(item) === -1) return;
                var _index = $this.Tags.indexOf(item);
                $this.Tags.splice(_index, 1);
}
static clearTags = ($this) => { $this.Tags = null; }

static GetFullCode($this: any): any{let vCode = (CLMS.Framework.String.IsNullOrEmpty($this?.Code) ? "" : $this?.Code?.trim());
if ($this?.Ledger?.AccountCodeRule != null && $this?.Ledger?.AccountCodeRule?.FillAllLevels) {let remaining = Joove.Common.safeNumber($this?.Ledger?.AccountCodeRule?.Levels) - Joove.Common.safeNumber(vCode?.length);vCode = vCode + CLMS.Framework.String.FillWith('0', remaining);}
let segment = ($this?.Ledger?.AccountCodeRule?.Segments?.linq?.any() ? $this?.Ledger?.AccountCodeRule?.Segments?.linq?.where()?.firstOrDefault(null) : null);
let seperator = ($this?.Ledger?.AccountCodeRule == null ? "." : segment?.Seperator);
if (seperator == null) {seperator = "";}
if ($this?.ParentChartOfAccount != null) {return $this?.ParentChartOfAccount?.FullCode + seperator + vCode;}else {return vCode;}
}
static GetFullName($this: any): any{return $this?.FullCode + " " + $this?.Description;
}
static GetLevel($this: any): any{let vLevel = null;
vLevel = 1;
if ($this?.ParentChartOfAccount != null) {return Joove.Common.safeNumber($this?.ParentChartOfAccount?.Level) + Joove.Common.safeNumber(vLevel);}else {return vLevel;}
}
static HasChildrenAccounts($this: any): any{return $this?.ChildChartOfAccounts?.linq?.any();
}
static IsUnder($this: any, acc: any): any{let current = $this;
while (current != null) {if (current == acc) {return true;}current = current?.ParentChartOfAccount;}
return false;
}
static MatchesCategories($this: any, selectedCategories: any): any{selectedCategories = selectedCategories?.linq?.where((c) => c?.Values?.linq?.any())?.toArray();
if (!($this?.Tags?.linq?.any()) && !(selectedCategories?.linq?.any())) {return true;}
if (!($this?.Tags?.linq?.any()) || !(selectedCategories?.linq?.any())) {return false;}
for (let _icatConfig = 0; _icatConfig < (selectedCategories == null ? 0 : selectedCategories.length); _icatConfig++) {let catConfig = selectedCategories[_icatConfig];let cats = $this?.Tags?.linq?.where((c) => c?.Category == catConfig?.Category)?.toArray();if (cats?.linq?.any((c) => catConfig?.Values?.linq?.contains(c?.Value))) {return true;}}
return false;
}
static SyncChildrenFullCodeAndLevel($this: any): any{for (let _ivChartOfAccount = 0; _ivChartOfAccount < ($this?.ChildChartOfAccounts == null ? 0 : $this?.ChildChartOfAccounts.length); _ivChartOfAccount++) {let vChartOfAccount = $this?.ChildChartOfAccounts[_ivChartOfAccount];Domain.Account.UpdateFullCodeAndLevel(vChartOfAccount, $this?.FullCode, $this?.Level);}
}
static UpdateCategoriesHierarchy($this: any): any{if ($this?.ParentChartOfAccount == null) {return;}
let childrensCategories = $this?.ParentChartOfAccount?.ChildChartOfAccounts;
let allTags = [];
for (let _iacc = 0; _iacc < (childrensCategories == null ? 0 : childrensCategories.length); _iacc++) {let acc = childrensCategories[_iacc];for (let _itag = 0; _itag < (acc?.Tags == null ? 0 : acc?.Tags.length); _itag++) {let tag = acc?.Tags[_itag];if (!(allTags?.linq?.any((t) => t?.Category == tag?.Category && t?.Value == tag?.Value))) {allTags?.add(tag);}if ($this?.ParentChartOfAccount?.Tags?.linq?.any((t) => t?.Category == tag?.Category && t?.Value == tag?.Value)) {continue;}else {let newTag = new Domain.AccountTag();Domain.AccountTag.setCategory(newTag, tag?.Category);Domain.AccountTag.setValue(newTag, tag?.Value);$this?.ParentChartOfAccount?.Tags?.add(newTag);}}}
let tagsToRemove = [];
for (let _itag = 0; _itag < ($this?.ParentChartOfAccount?.Tags == null ? 0 : $this?.ParentChartOfAccount?.Tags.length); _itag++) {let tag = $this?.ParentChartOfAccount?.Tags[_itag];if (!(allTags?.linq?.any((t) => t?.Category == tag?.Category && t?.Value == tag?.Value))) {tagsToRemove?.add(tag);}}
while ((tagsToRemove?.linq?.any())) {let toRemove = tagsToRemove?.linq?.where()?.firstOrDefault(null);tagsToRemove?.splice(tagsToRemove.indexOf(toRemove), 1);$this?.ParentChartOfAccount?.Tags?.splice($this?.ParentChartOfAccount?.Tags.indexOf(toRemove), 1);}
Domain.Account.UpdateCategoriesHierarchy($this?.ParentChartOfAccount);
}
static UpdateFullCodeAndLevel($this: any, vParentFullCode: any,vParentLevel: any): any{$this.FullCode = vParentFullCode + "." + $this?.Code;
$this.Level = Joove.Common.safeNumber(vParentLevel) + Joove.Common.safeNumber(1);
Domain.Account.SyncChildrenFullCodeAndLevel($this);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ChartOfAccountID == null || $this.ChartOfAccountID == 0;
            }


}